import type { FC, ReactNode } from 'react'

import { Heart } from 'lucide-react'
import { cn } from '@/lib/utils'

const HEARTS = [
    { left: '5%', size: 14, delay: 0, duration: 15, tint: 'opacity-40' },
    { left: '13%', size: 22, delay: 4, duration: 18, tint: 'opacity-25' },
    { left: '22%', size: 12, delay: 9, duration: 13, tint: 'opacity-50' },
    { left: '33%', size: 18, delay: 2, duration: 17, tint: 'opacity-30' },
    { left: '45%', size: 10, delay: 7, duration: 14, tint: 'opacity-50' },
    { left: '56%', size: 20, delay: 11, duration: 19, tint: 'opacity-25' },
    { left: '65%', size: 14, delay: 5, duration: 15, tint: 'opacity-40' },
    { left: '74%', size: 24, delay: 1, duration: 20, tint: 'opacity-20' },
    { left: '84%', size: 12, delay: 8, duration: 13, tint: 'opacity-50' },
    { left: '93%', size: 18, delay: 3, duration: 16, tint: 'opacity-30' }
]

interface FloatingHeartsProps {
    className?: string
}

const FloatingHearts: FC<FloatingHeartsProps> = ({ className }): ReactNode => {
    return (
        <div aria-hidden className={cn('pointer-events-none absolute inset-0 overflow-hidden motion-reduce:hidden', className)}>
            {HEARTS.map((heart) => (
                <span
                    key={heart.left}
                    className={cn('absolute -bottom-10', heart.tint)}
                    style={{ left: heart.left }}
                >
                    <Heart
                        className='block animate-float-up fill-current'
                        strokeWidth={0}
                        style={{
                            width: heart.size,
                            height: heart.size,
                            animationDelay: `${heart.delay}s`,
                            animationDuration: `${heart.duration}s`
                        }}
                    />
                </span>
            ))}
        </div>
    )
}

export default FloatingHearts
